<template>
	<div class="border border-15 p-3" style="background-color: rgb(245, 250, 253);">
		<label class="w-100">
			<span v-if="windowWidth>1000">
				فایل‌های خود را در این قسمت ضمیمه کنید.
			</span>
			<div
				id="customInput_file_cloude"
				class="text-center form-Control pointer text-success border-0"
				:class="textClass"
				@click="show = true"
				style="text-decoration: underline; background: none;"
			>
				<img
				width="25"
				:src="require('../../assets/img/upload.svg')"
				:alt="label"
				/>
				<span id="customInput_file_cloude_span" >
					{{ (value=='' || value==null)? label : value }}
				</span>
				<span v-if="error">
					( {{error_text}} )
				</span>
			</div>
			<div class="text-center">
				حداکثر حجم مجاز : 30 مگابایت
				<br>
				فرمت‌های مجاز: mp4, pdf, jpg, jpeg, png
			</div>
			<input
				type="file"
				id="files"
				class="d-none"
				:accept="accept"
				name="files"
				
				@change="uploadImages"
				v-if="inputCheck"
			/>
		</label>
		<div class="d-flex justify-content-center" style="flex-wrap: wrap;">
			<div
				class="border border-15 bg p-2 text-success m-1 d-flex align-items-center"
				style="width:200px;"
				v-for="(f, i) in files"
				:key="i"
				:title="f.fileName"
			>
				<span
					class="pointer d-flex text-truncate"
					@click="(e)=>{ rtr(f.fileUpload); }"
				>
					<img :src="require('../../assets/img/Tick-Circle.svg')" width="16" />
					<div class="w-100 text-truncate">
						&nbsp;
						{{ f.fileName }}
					</div>
				</span>
				
				<btn
					text=""
					:img="require('../../assets/img/Trash-Bin.svg')"
					style_btn="background-color: unset !important;"
					type="white text-danger"
					imgSize="16"
					textClass="p-0"
					@clickMe="rmv(i)"
				/>
			</div>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		export default {
			name: 'previewImage',
			data(){
				return {
					inputCheck: true,
				}
			},
			components: {
				btn,
			},
			props: {
				label: {
					type: String,
					default: "label",
				},
				value: {
					type: String,
					default: "",
				},
				accept: {
					type: String,
					default: "application/pdf, image/gif, image/jpeg, image/png",
				},
				textClass: {
					type: String,
					default: "",
				},
				files:{
					default: []
				},
				inputFile: {
					default: []
				},
				error: {
					default: true
				},
				error_text: {
					type: String,
					default: ""
				},
				leading: {
					type: String,
					default: "",
				},
			},
			mounted(){
				$(function () {
					$('[data-toggle="tooltip"]').tooltip()
				})
			},
			methods:{
				rmv(index){
					this.files.splice(index, 1);
					this.$emit('removeFile', this.files);
				},
				//____________________________________________________________________
				rtr(fileUpload){
					window.open(window.imgurl + fileUpload);
				},
				//______________________________________________________________________
				onFileChange(e, THIS = this){
					
				},
				uploadImages(e, THIS = this) {
					let image_id = Math.floor(Math.random() * (1000000 - 1000 + 1) + 1000);
					let name = "image_" + image_id;
					let imageData = null;
					let context = null;
					let maxWidth = 1024;
					let maxHeigt = 768;
					let width = maxWidth;
					let height = maxHeigt;
					var vm = this;
					let files = e.target.files;
					vm.imageIndex = 0;

					let formData = new FormData();
					for (let i = 0; i < files.length; i++) {
						let reader = new FileReader();
						let file = files[i];
						if (!file.type.match('image')) {
							this.$emit('chengeFile', e.target.files[0]);
							this.inputCheck = false;
							setTimeout(()=>{
								THIS.inputCheck = true;
							}, 10);
						};
						if (file) {
							var img = document.createElement("img");
							var canvas = $("<canvas/>").get(0);
							reader.onload = function (e) {
								img.src = e.target.result;

							};
							reader.readAsDataURL(file);
							img.onload = function () {
								// Draw
								context = canvas.getContext('2d');
								context.drawImage(img, 0, 0);
								if (img.width > maxWidth || img.height > maxHeigt) {
									width = maxWidth;
									height = maxHeigt;

									if (img.width > maxWidth) {
										width = maxWidth;
										var ration = maxWidth / img.width;
										height = Math.round(img.height * ration);
									}

									if (img.height > maxHeigt) {
										height = maxHeigt;
										var ration = maxHeigt / img.height;
										width = Math.round(img.width * ration);
									}
								} else {
									width = img.width;
									height = img.height;
								}
								canvas.width = width;
								canvas.height = height;

								context.drawImage(img, 0, 0, width, height);
								imageData = canvas.toDataURL('image/jpeg');
								imageData.replace('data:image/jpeg;base64,', '');

								let blobToFile = vm.dataURItoBlob(imageData);
								const cfile = new File(
									[blobToFile], name + ".jpg",
									{type: "image/jpeg", lastModified: Date.now()}
								);
								formData.append('ad_image', cfile);
								// upload to server with axios
								vm.$emit('chengeFile', cfile);
								vm.inputCheck = false;
								setTimeout(()=>{
									THIS.inputCheck = true;
								}, 10);
							}
						}
					}
				},
				dataURItoBlob(dataURI) {
					// convert base64 to raw binary data held in a string
					var byteString = atob(dataURI.split(',')[1]);
					// separate out the mime component
					var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
					// write the bytes of the string to an ArrayBuffer
					var arrayBuffer = new ArrayBuffer(byteString.length);
					var _ia = new Uint8Array(arrayBuffer);
					for (var i = 0; i < byteString.length; i++) {
						_ia[i] = byteString.charCodeAt(i);
					}
					var dataView = new DataView(arrayBuffer);
					var blob = new Blob([dataView], {type: mimeString});
					return blob;
				},

				//______________________________________________________________________
			}
		}
	</script>
<style>
	#customInput_file_cloude_span{
		transition: 0.3s;
	}
	#customInput_file_cloude_span:hover{
		color: #ff6839 !important;
}
</style>
